module.exports = {
  //commonUrl: "http://192.168.1.24:8090/",
  //rocketchatUrl: 'http://192.168.1.24:9010/api/v1/'
  commonUrl: "https://gnss.live/api/", //api url
  rocketchatUrl: 'https://dev-chat.navi-tech.net/', //rocketchat url
  websocketUrl: 'wss://gnss.live/api/ws?token='//websocket url
};
